export const LOCALE_PREFIX = 'components.Entity'
